[
  {
    "position": 1,
    "name": "life-insurance",
    "lobIds": [7],
    "icon": "product-family"
  },
  {
    "position": 2,
    "name": "home-insurance",
    "lobIds": [9],
    "icon": "product-apartment-building"
  },
  {
    "position": 3,
    "name": "car-insurance",
    "lobIds": [3, 8],
    "icon": "product-car-front"
  },
  {
    "position": 3,
    "name": "car-insurance-ek",
    "lobIds": [3, 8],
    "icon": "product-car-front"
  },
  {
    "position": 4,
    "name": "travel-insurance",
    "lobIds": [10],
    "icon": "product-plane"
  }
]
